// extracted by mini-css-extract-plugin
export default {"FlightsSearchControlsGCWrapper--fixed-height":"FlightsSearchControlsGCWrapper_FlightsSearchControlsGCWrapper--fixed-height__ZWE3N"};